import ReactGA from "react-ga4";

const useAnalyticsEventTracker = ({ category, action }) => {
    const eventTracker = () => {
        ReactGA.event({ category, action });
    }
    return eventTracker;
}
export default useAnalyticsEventTracker;